import { apiGet, apiPost, apiPut, apiDelete, apiPostForm, apiFetch, apiGetBlob } from "./apiClient";

const BASE = "/transaction-plans";

function buildQuery(params = {}) {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") return;

        // Column filters arrive as arrays; repeat the key so Spring binds a List.
        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item !== undefined && item !== null && item !== "") {
                    searchParams.append(key, item);
                }
            });
            return;
        }

        searchParams.append(key, value);
    });

    const query = searchParams.toString();
    return query ? `?${query}` : "";
}

export function getTransactionPlanPermissions() {
    return apiGet(`${BASE}/permissions`);
}

export function getTransactionPlans(params = {}) {
    return apiGet(`${BASE}${buildQuery(params)}`);
}

export function getTransactionPlanFilterOptions() {
    return apiGet(`${BASE}/filter-options`);
}

export function getTransactionPlanDetail(id) {
    return apiGet(`${BASE}/${id}`);
}

export function createTransactionPlan(payload) {
    return apiPost(BASE, payload);
}

export function updateTransactionPlan(id, payload) {
    return apiPut(`${BASE}/${id}`, payload);
}

export function deleteTransactionPlan(id) {
    return apiDelete(`${BASE}/${id}`);
}

export function previewTransactionPlanExcel(file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm(`${BASE}/excel/preview`, formData);
}

export function importTransactionPlanExcel(file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm(`${BASE}/excel/import`, formData);
}

export function uploadTransactionPlanInvoice(id, file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiPostForm(`${BASE}/${id}/invoice`, formData);
}

export function replaceTransactionPlanInvoice(id, file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiFetch(`${BASE}/${id}/invoice`, {
        method: "PUT",
        body: formData,
    });
}

export function deleteTransactionPlanInvoice(id) {
    return apiDelete(`${BASE}/${id}/invoice`);
}

export function viewTransactionPlanInvoice(id) {
    return apiGetBlob(`${BASE}/${id}/invoice`);
}

export function downloadTransactionPlanInvoice(id) {
    return apiGetBlob(`${BASE}/${id}/invoice/download`);
}

/** Deletes several rows and their invoices in one call. ADMIN and MODERATOR only. */
export function bulkDeleteTransactionPlans(ids) {
    return apiPost(`${BASE}/bulk-delete`, { ids });
}
